'use client';

import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useTranslations } from 'next-intl';

export default function FAQSection({ faqs }) {
  const [openIndex, setOpenIndex] = useState(null);
  const t = useTranslations('tarot.card');

  if (!faqs || faqs.length === 0) {
    return null;
  }

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="my-20 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
        <div className="absolute top-1/4 right-1/4 w-80 h-80 bg-[#A45DE8] rounded-full blur-[120px]"></div>
        <div className="absolute bottom-1/3 left-1/3 w-96 h-96 bg-[#D4B6FF] rounded-full blur-[150px]"></div>
      </div>
      
      <div className="w-full px-4 md:px-6 relative z-10">
        <h2 className="text-3xl font-serif text-center text-white mb-8 pb-3 mx-auto max-w-md">
          {t('faqTitle')}
        </h2>
        <div className="max-w-3xl mx-auto bg-[#050316]/80 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-[#6A3683]/50 shadow-[0_0_30px_rgba(164,93,232,0.15)]">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-[#6A3683]/30 last:border-0">
              <button
                onClick={() => toggleFAQ(index)}
                className="flex justify-between items-center w-full py-4 text-left focus:outline-none"
              >
                <h3 className="text-lg font-medium text-[#FBFBFE]">{faq.question}</h3>
                <ChevronDown
                  className={`w-5 h-5 text-purple-400 transition-transform duration-300 ${
                    openIndex === index ? 'transform rotate-180' : ''
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="text-gray-300">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 